//节流
const throttle = (fn, wait = 200, immediate = true) => {
    let timer = null;
    let callNow = immediate;
    return (...args) => {
        const cb = () => fn(...args);
        if (callNow) {
            cb();
            callNow = false;
        }
        if (!timer) {
            timer = setTimeout(() => {
                cb();
                timer = null;
            }, wait);
        }
    };
};

export {
    throttle
};
